module.exports = __webpack_public_path__ + "static/media/yappay.90bce9b4.svg";